import en from './en';
import fi from './fi';
import de from './de';
import sv from './sv';

import 'moment/locale/fi';
import 'moment/locale/de';
import 'moment/locale/sv';
import { Moment } from 'moment';

/** The locale has to be imported from moment/locale.
 * English is the default so it doesn't need importing. */
export const localizeMoment = (moment: Moment, locale: string): Moment => {
  return moment.locale(locale);
};

const locales: { [key: string]: LocaleType } = {
  en,
  fi,
  de,
  sv,
};

export default locales;
